<template>
    <div style="overflow-x: hidden;overflow-y: auto; height: 100%;">
        <div class="page_header">
            <span class="page_title">{{ $t('电池数据查询.page_title') }}</span>
            <div style="flex:1;text-align: right;">
                <quickQuery :isDownload="true" @handleQuery="onQuery" @quickQuery="onQuery" @download="onExport"
                    style="text-align: right" :isNow="true" />
            </div>
            <!-- <el-form :inline="true" :size="size" style="  flex:1;text-align: right;">
                <el-form-item :label="$t('time.timeQuery')">
                    <el-date-picker v-model="form.queryDate" type="daterange" :range-separator="$t('time.to')"
                        :start-placeholder="$t('time.startDate')" :end-placeholder="$t('time.endDate')"
                        value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onQuery" :loading="loading">{{ $t('public.query') }}</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button @click="onExport" :loading="loading" type="primary">{{ $t('public.export') }}</el-button>
                </el-form-item>
            </el-form> -->
        </div>
        <el-divider></el-divider>
        <div class="page_container">
            <div>
                <el-table :size="size" v-loading="loading" :data="tableData" tooltip-effect="dark" border
                    style="width: 100%">
                    <!-- <el-table-column
        v-for="column in columns"
        :key="column.fieldName"
        :prop="column.fieldName"
        :label="column.displayName"
         align="center"
      >
      </el-table-column> -->
                    <!-- 车牌号 -->
                    <el-table-column prop="CarNo" :label="$t('vehicle.carNo')" align="center" />
                    <!-- 时间 -->
                    <el-table-column prop="GpsDateTime" :label="$t('vehicle.time')" min-width="100" align="center">
                        <template slot-scope="scope">
                            {{ formatDate(scope.row.GpsDateTime) }}
                        </template>
                    </el-table-column>
                    <!-- SOC -->
                    <el-table-column prop="SOC" label="SOC(%)" align="center" />
                    <!-- 电池总电压(V) -->
                    <el-table-column prop="TotalVoltage" :label="$t('电池数据查询.电池总电压(V)')" align="center">
                        <template slot-scope="scope">
                            {{ formatValue(scope.row.TotalVoltage, "Voltage") }}
                        </template>
                    </el-table-column>
                    <!-- 电池总电流(A) -->
                    <el-table-column prop="TotalElectric" :label="$t('电池数据查询.电池总电流(A)')" align="center">
                        <template slot-scope="scope">
                            {{ formatValue(scope.row.TotalElectric, "Electric") }}
                        </template>
                    </el-table-column>


                    <!-- 单体电池电压最大值(V) -->
                    <el-table-column prop="MaxBatteryMonomerVoltageValue" :label="$t('电池数据查询.电池单体最大电压(V)')"
                        align="center">
                        <template slot-scope="scope">
                            {{ formatValue(scope.row.MaxBatteryMonomerVoltageValue, "BatteryMonomerVoltageValue") }}
                        </template>
                    </el-table-column>
                    <!-- 最大电压单体电池代号 -->
                    <el-table-column prop="MaxVoltageBatteryMonomerNo" :label="$t('电池数据查询.最大电压单体子系统号/电池代号')"
                        align="center">
                        <template slot-scope="scope">
                            {{ scope.row.MaxVoltageBatterySerialNo }}/{{ scope.row.MaxVoltageBatteryMonomerNo }}
                        </template>
                    </el-table-column>

                    <!-- 单体电池最小电压(V) -->
                    <el-table-column prop="MinBatteryMonomerVoltage" :label="$t('电池数据查询.电池单体最小电压(V)')" align="center">
                        <template slot-scope="scope">
                            {{ formatValue(scope.row.MinBatteryMonomerVoltage, "BatteryMonomerVoltageValue") }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="MinVoltageBatteryMonomerNo" :label="$t('电池数据查询.最小电压单体子系统号/电池代号')"
                        align="center">
                        <template slot-scope="scope">
                            {{ scope.row.MinVoltageBatterySerialNo }}/{{ scope.row.MinVoltageBatteryMonomerNo }}
                        </template>
                    </el-table-column>
                    <!-- 整组电池最高单体电池温度(°C) -->
                    <el-table-column prop="MaxTemp" :label="$t('电池数据查询.整组电池最高单体电池温度(°C)')" align="center">
                        <template slot-scope="scope">
                            {{ formatValue(scope.row.MaxTemp, "Temperature") }}
                        </template>
                    </el-table-column>
                    <!-- 最高温度探针序号 -->
                    <el-table-column prop="MaxTempSerialNo" :label="$t('电池数据查询.最高温度子系统号/探针序号')" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.MaxTempSerialNo }}/{{ scope.row.MaxTempProbeSerialNo }}
                        </template>
                    </el-table-column>

                    <!-- 整组电池最低单体电池温度(°C) -->
                    <el-table-column prop="MinTemp" :label="$t('电池数据查询.整组电池最低单体电池温度(°C)')" align="center">
                        <template slot-scope="scope">
                            {{ formatValue(scope.row.MinTemp, "Temperature") }}
                        </template>
                    </el-table-column>
                    <!-- 最低温度子系统号 -->
                    <el-table-column prop="MinTempSerialNo" :label="$t('电池数据查询.最低温度子系统号/探针序号')" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.MinTempSerialNo }}/{{ scope.row.MinTempProbeSerialNo }}
                        </template>
                    </el-table-column>



                </el-table>
                <kl-pagination style="margin-bottom: 10px;" :pageSize="form.PageSize" :total="total"
                    @current-change="pageChange" @size-change="sizeChange" :current-page.sync="form.PageNo">
                </kl-pagination>
            </div>


        </div>
    </div>
</template>
<script>
import { queryVehicle32960Data } from "@/http/vehicle";
import { getCommon32960Value } from "@/utils/longyi";
import { mapState } from "vuex";
import language from '@/utils/getLanguageId'
import quickQuery from '../components/generalOrQuickQuery.vue'
export default {
    name: "batteryHistory",
    components: {
        quickQuery,
    },
    data() {
        return {
            loading: false,
            tableData: [],
            columns: [
                {
                    fieldName: "CarNo",
                    displayName: this.$t("vehicle.carNo"),
                    dataType: "string",
                },
                {
                    fieldName: "MaxBatteryMonomerVoltageValue",
                    displayName: this.$t("电池数据查询.最大电压单体电池电压(V)"),
                    dataType: "float",
                },
                {
                    fieldName: "MaxVoltageBatteryMonomerNo",
                    displayName: this.$t("电池数据查询.最大电压单体子系统号/电池代号"),
                    dataType: "string",
                },
                {
                    fieldName: "MinBatteryMonomerVoltage",
                    displayName: this.$t("电池数据查询.电池单体最小电压(V)"),
                    dataType: "float",
                },
                {
                    fieldName: "MinVoltageBatteryMonomerNo",
                    displayName: this.$t("电池数据查询.最小电压单体子系统号/电池代号"),
                    dataType: "string",
                },],

            total: 0,
            initialized: false,
            form: {
                queryDate: this.getTodayDate(),
                PageNo: 1,
                PageSize: 10

            },
            LanguageId: 1,
            beginDate: "",
            endDate: "",

        }
    },
    computed: {
        ...mapState({
            //   opened: state => state.app.sidebar.opened,
            selectedVehicles: (state) => state.app.vehicles.selectedVehicles,
            size: (state) => state.app.size,
        }),

    },
    methods: {
        formatDate(time) {
            if(!time)
                return "";
            //替换 T Z
            time = time.replace("T", " ");
            time = time.replace("Z", "");
            return time;
            // return this.moment(time).format('YYYY-MM-DD HH:mm:ss');

        },
        formatValue(v, type) {
            return getCommon32960Value(v, type)
        },
        sizeChange(size) {
            this.form.PageSize = size;
            this.queryDataList();
        },
        pageChange(page) {
            this.form.PageNo = page;
            this.queryDataList();
        },
        getTodayDate() {
            //格式化为yyyy-MM-dd

            return [this.moment(new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000)).format('YYYY-MM-DD'), this.moment(new Date(new Date().getTime())).format('YYYY-MM-DD')]

        },
        onExport() {

            //数据导出
            this.queryDataList(1);
        },
        onQuery(val) {
            //根据不同的tab查询不同的数据
            this.beginDate = val.beginDate;
            this.endDate = val.endDate;
            this.queryDataList();

        },
        queryDataList(isExport) {
            isExport = isExport || 0;
            if (this.selectedVehicles.length == 0) {
                this.$message.warning(this.$t("vehicletrack.selectvehicle"));
                return;
            }
            if (this.selectedVehicles.length > 1) {
                this.$message.warning(this.$t("vehicletrack.selectmorevehicle"));
                return;
            }
            // console.log(this.selectedVehicles[0]);
            if (!this.beginDate || !this.endDate) {
                this.$message.error(this.$t('time.selectQueryTime'));
                return;
            }

            var vin = this.selectedVehicles[0].vincode
            //获取当前时间，并往前减去5分钟
            var now = new Date();
            var nowTime = now.getTime();
            var beforeTime = nowTime - 5 * 60 * 1000;
            var before = new Date(beforeTime);

            var beforeTime = before.getHours() + ":" + before.getMinutes() + ":" + before.getSeconds();

            //查询时间不能跨月
            if (this.beginDate.split("-")[1] != this.endDate.split("-")[1]) {
                this.$message.error(this.$t('time.查询时间不能跨月'));
                return;
            }
            this.loading = true;
            queryVehicle32960Data({
                "vin": vin,
                "startDate": this.beginDate + " 00:00:00",// "2025-06-24",
                "endDate": this.endDate + " " + beforeTime,
                "pageNum": this.form.PageNo,
                "pageSize": this.form.PageSize,
                "isExport": isExport,
                "language": this.LanguageId,
                "exportName": isExport == 1 ? this.$t('电池数据查询.电池数据') : "",
            }, isExport == 1 ? 'blob' : 'json').then(res => {
                this.loading = false;
                if (isExport == 1) {
                    let blob = new Blob([res], {
                        type: "application/vnd.ms-excel;charset=utf-8",
                    }); // 重点代码

                    let a = document.createElement("a");
                    a.href = window.URL.createObjectURL(blob);
                    a.download = this.$t('电池数据查询.电池数据') + '.xlsx'; // 默认文件名
                    // a.setAttribute(
                    //     "download",
                    //     "充电记录.xlsx"
                    // ); // 表名，自定义
                    // document.body.appendChild(a);
                    a.click(); // 执行下载
                    window.URL.revokeObjectURL(blob); // 释放ur
                    // window.open(settings.baseUrl + "longyi/xlsx/" + res.data)
                }
                else {

                    this.tableData = res.data.list;
                    this.total = res.data.total
                }
            });

        },

    },
    activated() {

    },
    mounted() {
        this.LanguageId = language(this.$store.getters.locale);

    },

}
</script>
<style scoped>
.chart-container {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #D9E4F8;

    margin-bottom: 20px;
}

.chart-container-chart {
    width: 100%;
    height: 380px;
}
</style>